module.exports = __webpack_public_path__ + "img/DealerIcons-Marine-On.3c894f7.jpg";